// MyComponent.tsx
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '../../../components/UI';
import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    ListItemIcon,
    makeStyles,
    Paper,
    Tooltip,
    Typography,
    Avatar,
} from '@material-ui/core';
import MapTimelineTabs from '../MapDetailsV3/components/MapTimelineTabs';
import L, { Polyline, useMap, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import '../styles.scss';
import useRiderMapStyles from './useTLMapStyles';
import Map from '../../../components/Map';
import useTLMapViewModal from './useTLMapViewModal';
import Header from '../MapDetailsV3/components/Header';
import DeviceInfo from '../MapDetailsV3/components/DeviceInfo';
import EVInfo from '../MapDetailsV3/components/EVInfo';
import DistanceInfo from '../MapDetailsV3/components/DistanceInfo';
import PlayBackControl from '../MapDetailsV3/components/PlayBackControl';
import { getBounds, getPolyLineMarkerData } from './helper';
import StartPointMarker from '../MapDetailsV3/components/StartPointMarker';
import EndPointMarker from '../MapDetailsV3/components/EndPointMarker';
import IdlePointMarkerCluster from '../MapDetailsV3/components/IdlePointMarkerCluster';
import useRiderMapPlayBackControl from './useTLMapPlayBackControl';
import TrackingMarker from '../MapDetailsV3/components/TrackingMarker';
import TimerCard from '../MapDetailsV3/components/TimerCard';
import MapResetButton from '../MapDetailsV3/components/MapResetButton';
import useTLMapPlayBackControl from './useTLMapPlayBackControl';
import moment from 'moment';
import { redFilledMarker } from '../../../components/Map/MarkerIcons';
import LocationOnIcon from '@material-ui/icons/LocationOn';
interface TeamLeadViewProps {
    [key: string]: any;
}
const TeamLeadMapView: React.FC<TeamLeadViewProps> = ({
    heliosTrackingData = [],
    staffTrackAndTrace,
    singleEVDetails,
    ...props
}) => {
    //global
    const activeControlIndex = 0;
    const staffId = props?.match?.params?.id
        ? props?.match?.params?.id
        : staffTrackAndTrace?.id;
    const singleEVMapDetails = singleEVDetails ?? null;
    const backEnabled = !!props?.match?.params?.id || false;
    const [containerHeight, setContainerHeight] = useState(0);
    const containerRef = React.useRef<HTMLElement>(null);
    const classes = useRiderMapStyles({
        containerHeight: containerHeight,
    });
    const {
        staffInformation,
        loading,
        selectedDate,
        setSelectedDate,
        routes,
        aggRoutes,
        routesPlaybackData,
        setEnableSetBounds,
        enableSetBounds,
        aggUserEvents,
        showCloseButton,
        stepperSelectorHandler,
        clearSelection,
        fetchData,
    } = useTLMapViewModal({ staffId, ...props });
    const deviceDetails = {
        deviceBrand: staffInformation?.deviceBrand,
        appVersion: staffInformation?.appVersion,
        deviceModel: staffInformation?.deviceModel,
        locationPermission: staffInformation?.locationPermission,
        locationService: staffInformation?.locationService,
    };
    const havingEV = false;

    const deviceBeeconId = staffInformation?.userInfoBrokerEntityId;
    const latestDeviceTrackingData =
        !!deviceBeeconId &&
        !!staffInformation?.helixVehicleDetails?.[deviceBeeconId]
            ? staffInformation?.helixVehicleDetails?.[deviceBeeconId]
            : {};

    useEffect(() => {
        if (!!containerRef?.current?.offsetHeight && !containerHeight) {
            const height = containerRef.current.offsetHeight;
            setContainerHeight(height);
        }
    }, [containerRef?.current?.offsetHeight]);
    const filteredRoutes = routesPlaybackData?.filter(
        (ar: any) => ar?.coordinates?.length > 1,
    );
    const {
        currentIndices,
        playing,
        enablePlayBackControl,
        handlePlayBack,
        setCurrentIndices,
        handlePause,
        handlePlay,
        handleSpeedChange,
        handleSliderChange,
        handleReset,
        setPlaying,
        speed,
        setSpeed,
        setEnablePlayBackControl,
        handleStop,
        handleForward,
        handleRewind,
    } = useTLMapPlayBackControl({
        aggRoutes: filteredRoutes,
    });
    console.log('Thee staffInformation', currentIndices);
    function SetBounds({ latLongPoints }: any) {
        const map = useMap();
        if (latLongPoints && latLongPoints.length > 0) {
            map.fitBounds(latLongPoints);
        }
        setEnableSetBounds(false);
        return null;
    }
    console.log('Staff Details  ddd', props?.location?.state?.backUrl);

    return (
        <Spinner loading={loading}>
            <Paper
                ref={containerRef}
                style={{ padding: '.1rem' }}
                className={classes.container}
                elevation={0}
            >
                <Grid container spacing={1}>
                    <Grid item md={4} xs={12}>
                        <Box
                            className={classes.routeContainer}
                            style={
                                showCloseButton
                                    ? { opacity: 0.4, pointerEvents: 'none' }
                                    : {}
                            }
                        >
                            <Header
                                backEnabled={backEnabled}
                                backUrl={
                                    props?.location?.state?.backUrl ??
                                    '/cluster-management'
                                }
                                staffName={staffInformation?.name}
                                selectedDate={selectedDate}
                                onSelectDate={(value: any) => {
                                    handleReset();
                                    setSelectedDate(value);
                                }}
                                contactNumber={
                                    staffInformation?.contactNumber ?? ''
                                }
                                hubName={staffInformation?.hubName ?? ''}
                                vehicleNumber={
                                    staffInformation?.vehicleNumber ?? ''
                                }
                                singleEVMapDetails={singleEVMapDetails}
                            />
                            {!!latestDeviceTrackingData?.telematicData && (
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'flex-start'}
                                    mt={'8px'}
                                >
                                    {!!latestDeviceTrackingData?.telematicData
                                        ?.ignitionStateChangeTime && (
                                        <Typography component={'span'}>
                                            {`Last Updated at : ${moment(
                                                latestDeviceTrackingData
                                                    ?.telematicData
                                                    ?.ignitionStateChangeTime,
                                            ).format('DD-MM-YYYY HH:mm:ss')}`}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                            {latestDeviceTrackingData?.telematicData?.gps
                                ?.lat &&
                                latestDeviceTrackingData?.telematicData?.gps
                                    ?.long && (
                                    <Box mt={'8px'} mb={'8px'}>
                                        <Typography component={'span'}>
                                            {`Last Location : `}
                                        </Typography>
                                        <IconButton
                                            aria-label="last-location"
                                            component={'a'}
                                            target={'_blank'}
                                            href={`https://www.google.com/maps?q=${latestDeviceTrackingData?.telematicData?.gps?.lat},${latestDeviceTrackingData?.telematicData?.gps?.long}`}
                                        >
                                            <LocationOnIcon color="primary" />
                                        </IconButton>
                                    </Box>
                                )}
                            {/* {!!staffInformation && (
                                <>
                                    <DeviceInfo
                                        device={deviceDetails}
                                        tracking={latestDeviceTrackingData}
                                    />
                                    <Divider style={{ margin: '12px 0' }} />
                                </>
                            )} */}
                            {
                                <>
                                    <DistanceInfo
                                        tracking={
                                            staffInformation?.trackingDetails
                                        }
                                        evTracking={
                                            staffInformation?.evTrackingDetails
                                        }
                                        events={staffInformation?.eventDetails}
                                        havingEV={havingEV}
                                        playComponent={
                                            <React.Fragment>
                                                {!havingEV &&
                                                    !!aggRoutes?.filter(
                                                        (rte: any) =>
                                                            rte?.coordinates
                                                                ?.length > 1,
                                                    )?.length && (
                                                        <PlayBackControl
                                                            enableControl={
                                                                enablePlayBackControl
                                                            }
                                                            onPlayBackClick={
                                                                handlePlayBack
                                                            }
                                                            playing={playing}
                                                            onPlayPress={
                                                                handlePlay
                                                            }
                                                            onPausePress={
                                                                handlePause
                                                            }
                                                            onForwardPress={
                                                                handleForward
                                                            }
                                                            onRewindPress={
                                                                handleRewind
                                                            }
                                                            onRestartPress={() => {}}
                                                            onSpeedChange={
                                                                handleSpeedChange
                                                            }
                                                            onSliderChange={
                                                                handleSliderChange
                                                            }
                                                            onStopPress={
                                                                handleStop
                                                            }
                                                            speed={speed}
                                                            routes={
                                                                filteredRoutes
                                                            }
                                                            currentIndexes={
                                                                currentIndices
                                                            }
                                                        />
                                                    )}
                                            </React.Fragment>
                                        }
                                    />
                                </>
                            }
                        </Box>
                        <Divider style={{ margin: 0 }} />
                        <MapTimelineTabs
                            showCloseButton={showCloseButton}
                            routes={routes}
                            events={staffInformation?.eventDetails}
                            aggUserEvents={aggUserEvents}
                            onDotClick={(point: any, index: number) => {
                                handleReset();
                                stepperSelectorHandler(point, index);
                            }}
                            onCloseClick={clearSelection}
                            aggRoutes={aggRoutes}
                            havingEV={havingEV}
                        />
                    </Grid>
                    <Grid
                        item
                        md={8}
                        xs={12}
                        style={
                            showCloseButton
                                ? { opacity: 0.4, pointerEvents: 'none' }
                                : {}
                        }
                    >
                        <Map
                            position={[13.034259, 80.24893]}
                            center={[13.034259, 80.24893]}
                            zoom={20}
                            scrollWheelZoom={true}
                        >
                            {!!enablePlayBackControl &&
                                routesPlaybackData.map(
                                    (route: any, i: number) => {
                                        const polyLineData =
                                            route?.coordinates?.slice(
                                                0,
                                                currentIndices?.[i],
                                            );
                                        const markerPos =
                                            route?.playBackData?.[
                                                currentIndices?.[i]
                                            ];
                                        return !!currentIndices?.[i] &&
                                            !!polyLineData &&
                                            !!markerPos ? (
                                            <React.Fragment
                                                key={`playback${i}`}
                                            >
                                                <Polyline
                                                    positions={polyLineData}
                                                    pathOptions={{
                                                        color:
                                                            route?.ui
                                                                ?.polyLineColor ??
                                                            'red',
                                                        weight:
                                                            route?.ui
                                                                ?.polyLineWeight ??
                                                            2,
                                                    }}
                                                />
                                                <TrackingMarker
                                                    label={route?.markerLabel}
                                                    playbackPosition={markerPos}
                                                ></TrackingMarker>
                                            </React.Fragment>
                                        ) : (
                                            <></>
                                        );
                                    },
                                )}
                            {!!enablePlayBackControl &&
                                !!routesPlaybackData?.length && (
                                    <TimerCard
                                        routes={routesPlaybackData}
                                        currentIndices={currentIndices}
                                    />
                                )}
                            {/* Current Location Marker */}
                            {latestDeviceTrackingData?.telematicData?.gps
                                ?.lat &&
                                latestDeviceTrackingData?.telematicData?.gps
                                    ?.long && (
                                    <Marker
                                        position={[
                                            latestDeviceTrackingData
                                                .telematicData.gps.lat,
                                            latestDeviceTrackingData
                                                .telematicData.gps.long,
                                        ]}
                                        icon={redFilledMarker}
                                    >
                                        <Popup>Current Location</Popup>
                                    </Marker>
                                )}
                            {!!aggRoutes?.length &&
                                aggRoutes?.map((route: any, i: number) => {
                                    return !!route?.coordinates?.length ? (
                                        <>
                                            <Polyline
                                                positions={route?.coordinates}
                                                pathOptions={{
                                                    color:
                                                        route?.polyLineColor ??
                                                        'black',
                                                    weight:
                                                        route?.polyLineWeight ??
                                                        2,
                                                }}
                                            />
                                            <StartPointMarker
                                                trackData={routes?.[i]}
                                                aggregatedTrackData={route}
                                                events={
                                                    staffInformation?.eventDetails
                                                }
                                            />
                                            <EndPointMarker
                                                trackData={routes?.[i]}
                                                aggregatedTrackData={route}
                                                events={
                                                    staffInformation?.eventDetails
                                                }
                                            />
                                            <IdlePointMarkerCluster
                                                aggregatedTrackData={route}
                                                events={
                                                    staffInformation?.eventDetails
                                                }
                                            />
                                        </>
                                    ) : null;
                                })}

                            {!!enableSetBounds && (
                                <SetBounds
                                    latLongPoints={getBounds(aggRoutes)}
                                />
                            )}
                            <MapResetButton
                                text={'&#x21BB;'}
                                onPress={() => {
                                    fetchData();
                                }}
                            />
                        </Map>
                    </Grid>
                </Grid>
            </Paper>
        </Spinner>
    );
};

export default TeamLeadMapView;
